<div class="payment-orders-table" [attr.data-test]="'payment-order-employee-table'">
	<div class="table-header flex">
		<div class="header-text flex flex-1 col-empid" id="employeeId">EMPLOYEE ID</div>
		<div class="header-text flex flex-1 col-empname" id="employeeName">NAME</div>
		<div class="header-text flex flex-1 col-surname" id="surname">SURNAME</div>
		<div class="header-text flex flex-1 col-net" id="amount">TOTAL NET</div>
		@if (isCPNowDeductionsEnabled() === true) {
		<div class="header-text flex flex-1 col-net" id="totalDeduction">TOTAL DEDUCTION</div>
		}
		<div class="header-text flex flex-1 col-source" id="source">UPLOADED BY</div>
	</div>
	@for(data of netPaymentOrders; track data.employeeId) {
	<div class="table-body">
		<div
			class="table-row flex"
			[ngClass]="{ 'row-integration': data.source === 'integration' }"
			[attr.data-test]="'employee-row-' + data.employeeExternalId"
		>
			<div class="table-row-item flex flex-1 col-emp" [attr.data-test]="'employee-id'">
				{{ data.employeeExternalId }}
			</div>
			<div class="table-row-item flex flex-1 col-empname" [attr.data-test]="'employee-name'">
				{{ data.employeeName }}
			</div>
			<div class="table-row-item flex flex-1 col-surname" [attr.data-test]="'employee-surname'">
				{{ data.surname }}
			</div>
			<div class="table-row-item flex flex-1 col-net field-amount" [attr.data-test]="'total-net'">
				{{ data.amount.value | currency : data.amount.currency : "symbol" : "1.2-2" }}
			</div>
			@if (isCPNowDeductionsEnabled() === true) { @if(!data.deductionAmount?.value) {
			<div class="table-row-item flex flex-1 col-net field-amount" [attr.data-test]="'total-deduction-empty'">
				-
			</div>
			} @else if(data.deductionAmount?.value) {
			<div class="table-row-item flex flex-1 col-net field-amount" [attr.data-test]="'total-deduction'">
				{{ data.deductionAmount?.value | currency : data.deductionAmount?.currency : "symbol" : "1.2-2" }}
			</div>
			} }

			<div class="table-row-item flex flex-1 col-source field-source" [attr.data-test]="'uploaded-by'">
				<app-icon
					class="source-icon"
					[name]="data.source === 'file' ? 'document-upload' : 'receipt-add'"
					[color]="'var(--color-role-titl)'"
					[size]="'24'"
					[lineWidth]="'1.5px'"
				></app-icon>
				<div class="source-value">
					{{ (data?.source?.toUpperCase() === "INTEGRATION" ? "payroll integration" : "file") | uppercase }}
				</div>
			</div>
		</div>
	</div>
	} @empty {
	<ng-container>
		<no-items-layout message="No records yet" [attr.data-test]="'no-records'"></no-items-layout>
	</ng-container>
	}
</div>
